import React, { memo } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import { useAuth } from '../contexts/auth.context';
import PrivateRoute from '../components/PrivateRoute';
import { MainLayout } from '../layouts';

import {
  PATIENTS_ROUTE,
  PATIENT_VIEW_ROUTE,
  USERS_ROUTE,
  USER_EDIT_ROUTE,
  USER_REGISTER_ROUTE,
  SIGNIN_ROUTE,
  PASSWORD_CHANGE_ROUTE,
  FORGET_PASSWORD_ROUTE,
  USER_RESET_PASSWORD,
  PATIENT_RESET_PASSWORD,
  PATIENT_REGISTER_ROUTE,
  PATIENT_EDIT_ROUTE,
  ACCREDITEDS_ROUTE,
  ACCREDITED_REGISTER_ROUTE,
  ACCREDITED_EDIT_ROUTE,
  FORMS_ROUTE,
  FORMS_EDIT_ROUTE,
  FORMS_REGISTER_ROUTE,
  FORMS_VIEW_ROUTE,
  FORMS_TEVA_ROUTE
} from '../constants';
import UserListPage from '../pages/users/list';
import UserRegisterPage from '../pages/users/register';
import PatientRegisterPage from '../pages/patients/register/index';
import UserChangePasswordComponent from '../components/User/ChangePassword';
import PatientListPage from '../pages/patients/list';
import PatientViewPage from '../pages/patients/detailedView';

import LoginComponent from '../components/SignIn';
import ForgetPasswordComponent from '../components/ForgetPassword';
import AccreditedListPage from '../pages/accrediteds/list';
import AccreditedRegisterPage from '../pages/accrediteds/register';
import FormListPage from '../pages/forms/list';
import FormRegisterPage from '../pages/forms/register';

import StepperFormPage from '../pages/formsStepsTeva';

function Routes() {
  const { isLoading } = useAuth();

  if (isLoading) {
    return <div />;
  }

  return (
    <BrowserRouter>
      <Switch>
        <Route path="/" exact component={LoginComponent} />
        <Route path={SIGNIN_ROUTE} exact component={LoginComponent} />
        <Route
          path={FORGET_PASSWORD_ROUTE}
          exact
          component={ForgetPasswordComponent}
        />
        <Route
          path={USER_RESET_PASSWORD}
          exact
          component={UserChangePasswordComponent}
        />
        <Route path={PATIENT_RESET_PASSWORD} exact component={React.Fragment} />
        <Route path={FORMS_TEVA_ROUTE} exact component={StepperFormPage} />
        <PrivateRoute path="/" component={React.Fragment}>
          <MainLayout>
            <Switch>
              <PrivateRoute
                path={PATIENTS_ROUTE}
                exact
                component={PatientListPage}
                allowedRoles={['ADMIN', 'NURSE']}
              />
              <PrivateRoute
                path={PATIENT_VIEW_ROUTE}
                exact
                component={PatientViewPage}
                allowedRoles={['ADMIN', 'NURSE']}
              />
               <PrivateRoute
                path={PATIENT_REGISTER_ROUTE}
                exact
                component={PatientRegisterPage}
                allowedRoles={['ADMIN', 'NURSE']}
              />
               <PrivateRoute
                path={PATIENT_EDIT_ROUTE}
                exact
                component={PatientRegisterPage}
                allowedRoles={['ADMIN', 'NURSE']}
              />

              <PrivateRoute
                path={FORMS_ROUTE}
                exact
                component={FormListPage}
                allowedRoles={['ADMIN', 'NURSE']}
              />
              <PrivateRoute
                path={FORMS_VIEW_ROUTE}
                exact
                component={PatientViewPage}
                allowedRoles={['ADMIN', 'NURSE']}
              />
               <PrivateRoute
                path={FORMS_REGISTER_ROUTE}
                exact
                component={FormRegisterPage}
                allowedRoles={['ADMIN', 'NURSE']}
              />
               <PrivateRoute
                path={FORMS_EDIT_ROUTE}
                exact
                component={PatientRegisterPage}
                allowedRoles={['ADMIN', 'NURSE']}
              />

              <PrivateRoute
                path={ACCREDITEDS_ROUTE}
                exact
                component={AccreditedListPage}
                allowedRoles={['ADMIN']}
              />
               <PrivateRoute
                path={ACCREDITED_REGISTER_ROUTE}
                exact
                component={AccreditedRegisterPage}
                allowedRoles={['ADMIN']}
              />
               <PrivateRoute
                path={ACCREDITED_EDIT_ROUTE}
                exact
                component={AccreditedRegisterPage}
                allowedRoles={['ADMIN']}
              />

              <PrivateRoute 
                path={USERS_ROUTE} 
                exact 
                component={UserListPage} 
                allowedRoles={['ADMIN']}
              />
              <PrivateRoute
                path={USER_EDIT_ROUTE}
                exact
                component={UserRegisterPage}
                allowedRoles={['ADMIN']}
              />
              <PrivateRoute
                path={USER_REGISTER_ROUTE}
                exact
                component={UserRegisterPage}
                allowedRoles={['ADMIN']}
              />
              <PrivateRoute
                path={PASSWORD_CHANGE_ROUTE}
                exact
                component={UserChangePasswordComponent}
                allowedRoles={['ADMIN']}
              />
            </Switch>
          </MainLayout>
        </PrivateRoute>
      </Switch>
    </BrowserRouter>
  );
}

export default memo(Routes);

